import * as THREE from 'three';
import { useGLTF } from '@react-three/drei';

export default function Generator({ opacity = 1, ...props }) {
    const glowBlue = new THREE.MeshBasicMaterial({ 
        color: new THREE.Color(0, 0.3, 20), 
        toneMapped: false,
        transparent: true,
        opacity: opacity 
    });

    const { nodes } = useGLTF('./models/generator.glb');

    return (
        <group {...props} dispose={null}>
            <mesh 
                geometry={nodes.generator.geometry} 
                material={glowBlue} 
                position={[-402.354, 6.2, -282.407]} 
            />
        </group>
    );
}
